// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__UohFh","l1":"loader_l1__IbjVG"};